export default function SourceBadge({ source }) {
  const map = {
    product_inquiry: { label: 'Product', color: '#0A3F22', bg: '#EAF2EC' },
    contact_form: { label: 'Contact', color: '#1E40AF', bg: '#DBEAFE' },
  };
  const s = map[source] || { label: source || 'Lead', color: '#6B7280', bg: '#F3F4F6' };
  return (
    <span className="px-2 py-0.5 rounded-full text-xs font-semibold" style={{ color: s.color, backgroundColor: s.bg }}>
      {s.label}
    </span>
  );
}
